export default {
  ballon: {
    backgroundColor: '#e63027',
  },
};
